import * as React from 'react';
import Modal from 'react-modal';
import { Location } from 'lib/ReactRouterTypes';
import { WithRouterProps, withRouter } from 'react-router';
import JoinGroupModal from 'groups/components/JoinGroupModal';

import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';
import Group from 'entities/Group';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal';

type Props = {
  location: Location;
} & WithRouterProps;

type State = {
  code: string | null;
};

class JoinGroupHandler extends React.Component<Props, State> {
  state: State = {
    code: null,
  };

  static getDerivedStateFromProps(nextProps: Props) {
    return {
      code: nextProps.location.query.code,
    };
  }

  clearStateCode = () => this.setState({ code: null });
  redirectToClasses = () => this.props.router.replace('/classes');
  redirectToClass = (g: Group) => this.props.router.push(getRedirectLocationAfterGroupJoin(g));

  render() {
    const { code } = this.state;

    // prettier-ignore
    const modal = code
      ? <JoinConfirmSubscriptionModal code={code} onGroupNotFound={this.clearStateCode} onRequestHide={this.clearStateCode} />
      : <JoinGroupModal onJoin={this.redirectToClass} onRequestHide={this.redirectToClasses} />

    return (
      <Modal key="1" isOpen>
        {modal}
      </Modal>
    );
  }
}

export { JoinGroupHandler };
export default withRouter(JoinGroupHandler);
